import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Stars } from "./Stars";
import { euro, imgUrl } from "@/lib/api";

export const ProductCard = ({ p, i = 0 }) => (
  <Link
    to={`/servizi/${p.id}`}
    className="group relative bg-[#18181C] border border-zinc-800 hover:border-red-600 transition-colors duration-150 flex flex-col reveal"
    style={{ animationDelay: `${i * 70}ms` }}
    data-testid={`product-card-${p.id}`}
  >
    <div className="relative aspect-[4/3] overflow-hidden">
      <img src={imgUrl(p.image_url)} alt={p.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#18181C] via-transparent to-transparent" />
      <span className="absolute top-3 left-3 bg-black/80 text-[10px] uppercase tracking-[0.2em] px-2 py-1 text-zinc-300">{p.category}</span>
    </div>
    <div className="p-5 flex flex-col gap-3 flex-1">
      <h3 className="font-display italic font-extrabold uppercase text-2xl leading-none">{p.name}</h3>
      <div className="flex items-center gap-2 text-xs text-zinc-500">
        <Stars value={p.rating_avg} />
        <span>{p.rating_count ? `${p.rating_avg} (${p.rating_count})` : "Nessuna recensione"}</span>
      </div>
      <p className="text-sm text-zinc-400 flex-1">{p.short_description}</p>
      <div className="flex items-end justify-between pt-2 border-t border-zinc-800">
        <span className="font-display italic font-black text-3xl text-red-500" data-testid={`product-price-${p.id}`}>{euro(p.price)}</span>
        <span className="flex items-center gap-1 text-xs uppercase tracking-widest text-zinc-400 group-hover:text-white transition-colors">
          Dettagli <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
        </span>
      </div>
    </div>
  </Link>
);
